import { render } from "./ImageUploadGuide.vue?vue&type=template&id=09002741&scoped=true"
import script from "./ImageUploadGuide.vue?vue&type=script&lang=js"
export * from "./ImageUploadGuide.vue?vue&type=script&lang=js"

import "./ImageUploadGuide.vue?vue&type=style&index=0&id=09002741&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09002741"]])

export default __exports__